<div class="container-fluid p-2 p-md-3 px-0">
  @if (isLoading()) {
    <div class="text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Caricamento organizzazione...</span>
      </div>
    </div>
  } @else {
    <div class="row g-4">
      <div [class]="isEditMode() && selectedOrganization() ? 'col-12 col-lg-7' : 'col-12'">
        <app-generic-form [title]="isEditMode() ? 'Modifica Organizzazione' : 'Nuova Organizzazione'" [wide]="true">
          <form [formGroup]="editOrganizationForm" (ngSubmit)="onSubmit()" form-content>
            <div class="mb-3">
              <label for="organizationName" class="form-label">Nome *</label>
              <input id="organizationName" type="text" class="form-control" formControlName="organizationName"
                placeholder="Nome organizzazione">
            </div>

            <div class="mb-3">
              <label for="organizationDescription" class="form-label">Descrizione</label>
              <textarea id="organizationDescription" class="form-control" formControlName="organizationDescription"
                placeholder="Descrizione organizzazione" rows="3"></textarea>
            </div>

            <div class="mb-3">
              <label for="organizationLogo" class="form-label">Logo URL</label>
              <input id="organizationLogo" type="text" class="form-control" formControlName="organizationLogo"
                placeholder="https://...">
            </div>

            <div class="mb-3">
              <label for="organizationWebsite" class="form-label">Sito Web</label>
              <input id="organizationWebsite" type="text" class="form-control" formControlName="organizationWebsite"
                placeholder="https://...">
            </div>

            <div class="mb-3">
              <label for="organizationEmail" class="form-label">Email</label>
              <input id="organizationEmail" type="email" class="form-control" formControlName="organizationEmail"
                placeholder="email@example.com">
            </div>

            <div class="mb-3">
              <label for="organizationPhone" class="form-label">Telefono</label>
              <input id="organizationPhone" type="text" class="form-control" formControlName="organizationPhone"
                placeholder="+39 ...">
            </div>

            <div class="mb-3">
              <app-location-form [parentForm]="editOrganizationForm" [organizationMode]="true"></app-location-form>
            </div>

            <div class="mb-3 form-check">
              <input id="organizationActive" type="checkbox" class="form-check-input"
                formControlName="organizationActive">
              <label for="organizationActive" class="form-check-label">Attiva</label>
            </div>

            <div class="d-flex gap-2 mt-4">
              <button type="submit" class="btn btn-primary" [disabled]="!canSave() || editOrganizationForm.invalid"
                [title]="canSave() ? '' : 'Non hai i permessi per questa azione'">
                <i class="bi" [class.bi-check-lg]="isEditMode()" [class.bi-plus-lg]="!isEditMode()" aria-hidden="true"></i>
                <span class="ms-1">{{ isEditMode() ? 'Aggiorna' : 'Crea' }}</span>
              </button>
              <button type="button" class="btn btn-secondary" (click)="goBack()">
                <i class="bi bi-x-lg me-1" aria-hidden="true"></i>Annulla
              </button>
            </div>
          </form>
        </app-generic-form>
      </div>

      @if (isEditMode() && selectedOrganization()) {
      <div class="col-12 col-lg-5">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title mb-3"><i class="bi bi-people me-2"></i>Membri</h5>
            <app-organization-members-manager [organization]="selectedOrganization()!">
            </app-organization-members-manager>
          </div>
        </div>
      </div>
      }
    </div>
  }
</div>
